import { useCallback, useState } from "react";

import {
  CalculationResult,
  MediumEnum,
  SubOrderRequest,
} from "../../../../api";
import CalculateGrpBudget from "./CalculateGrpBudget";

const CalculateGrpBudgetWrapper = ({
  value,
  onChange,
  record,
  dataIndex,
  medium,
  productId,
  requestDate,
  onCalculated,
}: {
  // Hooks to support Form.Item
  value?: number;
  onChange?: (newValue: number) => void;

  // Custom attributes
  record: SubOrderRequest;
  dataIndex: keyof SubOrderRequest;
  medium: MediumEnum;
  productId: number;
  requestDate?: Date;
  onCalculated: (values: CalculationResult) => void;
}) => {
  const [changedField, setChangedField] = useState<string>("");

  const handleActivateField = useCallback(
    (
      event:
        | React.MouseEvent<HTMLInputElement>
        | React.FocusEvent<HTMLInputElement>
    ) => {
      const name =
        (event as React.FocusEvent<HTMLInputElement>)?.target.name ??
        event.currentTarget.name;
      if (changedField === name) {
        return;
      }
      setChangedField(name);
    },
    [changedField]
  );

  const handleDeactivateField = useCallback(() => {
    setChangedField("");
  }, []);

  return (
    <CalculateGrpBudget
      value={value}
      onChange={onChange}
      subOrder={record}
      medium={medium}
      productId={productId}
      requestDate={requestDate}
      onCalculated={onCalculated}
      name={dataIndex}
      isActive={changedField === dataIndex}
      onClick={handleActivateField}
      onBlur={handleDeactivateField}
      id={`${dataIndex}EditableTable`}
    />
  );
};

export default CalculateGrpBudgetWrapper;
